
import * as cloudflareRuntime$_9i7oxONSIBm5Ke8kD2kKegP8F_456niqw8m_HbKq8X_455c from '/Users/q/code/nodejscn/nuxt/src/nuxt.com/node_modules/.pnpm/@nuxt+image@https+++pkg.pr.new+@nuxt+image@1a5786c_@netlify+blobs@8.2.0_db0@0.3.2_bette_67232f9a1a38608f472892b340607eab/node_modules/@nuxt/image/dist/runtime/providers/cloudflare'
import * as ipxRuntime$UOh6iFOi_45BpAsQdMae1eYfGjV2fXBogcJ2D275LmsGY from '/Users/q/code/nodejscn/nuxt/src/nuxt.com/node_modules/.pnpm/@nuxt+image@https+++pkg.pr.new+@nuxt+image@1a5786c_@netlify+blobs@8.2.0_db0@0.3.2_bette_67232f9a1a38608f472892b340607eab/node_modules/@nuxt/image/dist/runtime/providers/ipx'
import * as noneRuntime$td6SxcTVi3z_PE0IlRQbXwiOozm9HYaAqAC9F45DgGg from '/Users/q/code/nodejscn/nuxt/src/nuxt.com/node_modules/.pnpm/@nuxt+image@https+++pkg.pr.new+@nuxt+image@1a5786c_@netlify+blobs@8.2.0_db0@0.3.2_bette_67232f9a1a38608f472892b340607eab/node_modules/@nuxt/image/dist/runtime/providers/none'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "cloudflare",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "jpeg",
    "jpg",
    "png",
    "svg",
    "webp"
  ]
}

imageOptions.providers = {
  ['cloudflare']: { provider: cloudflareRuntime$_9i7oxONSIBm5Ke8kD2kKegP8F_456niqw8m_HbKq8X_455c, defaults: {"baseURL":"https://nuxt.com"} },
  ['ipx']: { provider: ipxRuntime$UOh6iFOi_45BpAsQdMae1eYfGjV2fXBogcJ2D275LmsGY, defaults: {"baseURL":"https://ipx.nuxt.com"} },
  ['none']: { provider: noneRuntime$td6SxcTVi3z_PE0IlRQbXwiOozm9HYaAqAC9F45DgGg, defaults: {} }
}
        